import * as Icons from "lucide-react";
import { DIFERENCIAIS } from "../../lib/site";

export const Diferenciais = () => {
  return (
    <section
      id="diferenciais"
      data-testid="diferenciais-section"
      className="relative py-24 md:py-32 border-t border-white/5 bg-gradient-to-b from-transparent to-[#07060c]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="max-w-3xl">
          <span className="overline">Diferenciais</span>
          <h2 className="font-display mt-4 text-3xl md:text-5xl font-medium tracking-tight text-white leading-[1.08]">
            Por que empresas e famílias{" "}
            <span className="text-white/60 italic font-light">confiam</span> no Grupo Nexus.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border border-white/5 rounded-[24px] overflow-hidden bg-[#08070d]">
          {DIFERENCIAIS.map((d, i) => {
            const Icon = Icons[d.icon] ?? Icons.Sparkles;
            return (
              <div
                key={d.title}
                data-testid={`diferencial-${i}`}
                className="relative p-8 md:p-10 border-b border-r border-white/5 group hover:bg-white/[0.02] transition-colors duration-300"
              >
                <div className="flex items-center gap-3">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-gradient-to-br from-[#1a103c] to-[#0A0810]">
                    <Icon size={18} strokeWidth={1.5} className="text-white/90" />
                  </span>
                  <span className="font-display text-sm text-white/45">0{i + 1}</span>
                </div>
                <h3 className="font-display mt-6 text-xl md:text-[22px] text-white font-medium leading-snug">
                  {d.title}
                </h3>
                <p className="mt-3 text-[14.5px] text-[#9f9caf] leading-relaxed">{d.desc}</p>
                <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Diferenciais;
